<script setup lang="ts">
import { computed } from 'vue';
import { useDisplayNames } from '#imports';

const props = defineProps<{
	relationFieldName?: string | null;
}>();
const displayName = defineModel<string | null>('displayName');
const description = defineModel<string | null>('description');

const { getSingleRelationFieldDisplayName } = useDisplayNames();

const displayNamePlaceholder = computed(() => getSingleRelationFieldDisplayName({
	apiName: props.relationFieldName ?? '',
	meta: null,
}));
</script>

<template>
	<DFormField
		name="displayName"
		:label="$t('common.display_name')"
		:description="$t('pages.data_model.display_name_description')"
	>
		<DInput v-model.nullable="displayName" :placeholder="displayNamePlaceholder" />
	</DFormField>
	<DFormField
		name="description"
		:label="$t('pages.data_model.field_description')"
		:description="$t('pages.data_model.field_description_description')"
	>
		<DInput v-model.nullable="description" />
	</DFormField>
</template>
